import { assets } from '@/ui/assets'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { ConnectCTAPanel } from '@/ui/organisms/connect-cta-panel/ConnectCTAPanel'

const icons = assets.walletIcons
const WALLET_ICONS_PATHS = [icons.metamask, icons.walletConnect, icons.coinbase]

export interface GuestViewProps {
  openConnectModal: () => Promise<void> | void
  header?: string
  source?: string
}

export function GuestView({
  openConnectModal,
  header = 'Connect your wallet to use HypurrFi',
  source = 'guest_view',
}: GuestViewProps) {
  return (
    <PageLayout className="items-center justify-center">
      <ConnectCTAPanel
        header={header}
        iconPaths={WALLET_ICONS_PATHS}
        action={openConnectModal}
        buttonText="Connect wallet"
        source={source}
      />
    </PageLayout>
  )
}
